// App Store listing URL. This drives /mobile-app and the home-page mobile app
// section: a non-empty value shows the "Download on the App Store" button; set
// it to "" to revert /mobile-app back to the email waitlist (no env var or
// redeploy config needed either way).
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/jobharvest/id6762484907";
export const IS_LIVE = Boolean(APP_STORE_URL);
